import HealtCarCard from "./HealtCarCard"

export default  HealtCarCard;
